
<div class="ft-modal-header document-dialog">
  @if (dirtyClass==='show'?true:false) {
  <button type="button" mat-icon-button
    class="modelSave" data-dismiss="modal" aria-hidden="true" (click)="ok()"> <mat-icon>check</mat-icon>
  </button>
  }
  @if (showSpinner) {
  <div class="spinner-wrap"
    id="spinnerIcon">
    <mat-spinner [diameter]="24"></mat-spinner>
  </div>
  }
  
  @if (data.title) {
  <h1 mat-dialog-title>{{data.title}} </h1>
  }

  <button type="button" mat-icon-button class="close-button" [mat-dialog-close]="true" (click)="cancel()">
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>

<form mat-dialog-content
  [formGroup]="formGroup" name="ftForm" role="form">
  <ft-template
      [formGroup]="formGroup"
      [formParameters]="data.formParameters"
      [user]="user"
      class="document-dialog-template"
  ></ft-template>
</form>
